import { BoxGeometry, Mesh, MeshStandardMaterial, Scene } from 'three';
import { extendShaderWithWorldGradient } from '../utils/shader_utils';
import BoxWithBottomOrigin from '../utils/box_bottom_origin';

class PoolBeach {
  
  private beach:BoxWithBottomOrigin
  fixedLength = 0.5; // Fixed length of the pool beach
  private color: number;
  private isInEditMode = false;
  constructor(private poolLength: number, private poolWidth: number, private poolDepth: number) {
  }

  private updatePosition() {
    // Position it just below the water surface and at the end of the pool
    this.beach.getMesh(). position.set((this.poolLength - this.fixedLength) / 2, -this.poolDepth, 0);
  }

  addToScene(scene: Scene) {
    scene.add(this.beach.getMesh());
  }

  updateColor(newColor?:number) {
    if (newColor!=null) this.color = newColor;
    const material = new MeshStandardMaterial({ color: this.color,metalness: 1.0,
      roughness: 1.0, }); 
      extendShaderWithWorldGradient(material, 0);
    this.beach.getMesh().material = material;
  }

  resize(poolLength: number, poolWidth: number, poolDepth: number, scene: Scene) {
    // Remove the old mesh from the scene
    if (this.beach!=null) {
      scene.remove(this.beach.getMesh());
      this.beach=null;
    }

    if (this.fixedLength==0) return

    // Update the dimensions
    this.poolLength = poolLength;
    this.poolWidth = poolWidth;
    this.poolDepth = poolDepth;

    if (this.isInEditMode) return;

    // Create a new mesh with the updated dimensions
    this.beach= new BoxWithBottomOrigin(this.fixedLength, this.poolDepth - 0.4, this.poolWidth);
  
    this.beach.getMesh().castShadow = true;
    this.beach.getMesh().receiveShadow = true;

    this.updatePosition();  // Update position
    this.updateColor();
    // Add the mesh back to the scene
    scene.add(this.beach.getMesh());
  }

  toggle(enabled:boolean, scene: Scene, poolLength: number, poolWidth: number, poolDepth: number) {
    if (enabled)
      this.fixedLength = 0.5 
    else
      this.fixedLength = 0.0

    this.poolDepth = poolDepth;
    this.poolLength = poolLength;
    this.poolWidth = poolWidth;

    this.resize(this.poolLength, this.poolWidth, this.poolDepth, scene);
  }

  setEditMode(isEditMode: boolean, scene: Scene) {
    this.isInEditMode = isEditMode;

    this.resize(this.poolLength, this.poolWidth, this.poolDepth, scene);
  }
}

export default PoolBeach;
